export abstract class Role {
	constructor(
		public name: string,
		public value: number
	) {}
}

/**
 * Category: Fleet
 */
export class FleetRole extends Role {
	static readonly FleetAdministrator = new FleetRole("FleetAdministrator", 4)
	static readonly FleetOperator = new FleetRole("FleetOperator", 2)
	static readonly FleetObserver = new FleetRole("FleetObserver", 1)
}

/**
 * Category: Device
 */
export class DeviceRole extends Role {
	static readonly DeviceOwner = new DeviceRole("DeviceOwner", 1)
}

/**
 * Category: Usermanagement
 */
export class UsermanagementRole extends Role {
	static readonly UserAdministrator = new UsermanagementRole("UserAdministrator", 2)
	static readonly UserOperator = new UsermanagementRole("UserOperator", 1)
}
